import { FormikValues } from 'formik';
import { mapToMfeValue } from './form/subjectHelpers';

const mapValue = (paramName: string, value: string): string => {
  if (paramName === 'trialSessionSubject') {
    return mapToMfeValue(value);
  }

  return value;
};

export const fillUrlValues = (url: string, formikValues: FormikValues) => {
  const urlObject = new URL(url, window.location.origin);
  const { searchParams } = urlObject;
  const entries = searchParams.entries();
  const paramsToDelete = [];
  let param;

  do {
    param = entries.next();

    if (param && param.value) {
      const [paramKey, paramValue] = param.value;

      if (paramValue.startsWith('{{') && paramValue.endsWith('}}')) {
        const formikKey = paramValue.slice(2, -2);

        if (formikValues[formikKey]) {
          searchParams.set(
            paramKey,
            mapValue(formikKey, formikValues[formikKey]),
          );
        } else {
          paramsToDelete.push(paramKey);
        }
      }
    }
  } while (!param.done);

  paramsToDelete.forEach((paramKey) => searchParams.delete(paramKey));

  return urlObject.toString();
};

export const addCurrentUrlParamsToUrl = (url: string) => {
  try {
    const { searchParams } = new URL(window.location.href);

    const urlObject = new URL(url, window.location.origin);
    searchParams.forEach((value, key) =>
      urlObject.searchParams.append(key, value),
    );

    return urlObject.toString();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error, url);
    return url;
  }
};
